import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { getConfig } from '@gokrew/ui/runtime-config';

/**
 * Payroll routes: hidden behind the `ENABLE_PAYROLL_EXPORT` build flag
 * until payroll integration v1 ships (spec 2026-10-13, PR 5). A bookmarked
 * URL goes back to the dashboard. The backend routes stay behind
 * `payroll_export.read` either way.
 */
export function PayrollExportGuard({ children }: { children: ReactNode }) {
  if (!getConfig().ENABLE_PAYROLL_EXPORT) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
